module.exports = __webpack_public_path__ + "static/jinx_swoop-f77f5d2e884269053f09f093fb3d7d96.png";